import React from 'react';
import PropTypes from 'prop-types';
import spine from '../../3p/spine-runtimes/spine-ts/build/spine-widget';
import { APP_ROOT_PATH } from '../../constants/url';
import { actionOnKeyboardPress } from '../utils/browserUtils';

export default class AnimationView extends React.Component {
    componentDidMount() {
        if (this.props.animationId === null) {
            return;
        }

        this.widget = new spine.SpineWidget(this.animationWidget, {
            json: `/${APP_ROOT_PATH}/static/spine/${this.props.animationId}.json`,
            atlas: `/${APP_ROOT_PATH}/static/spine/${this.props.animationId}.atlas`,
            animation: this.props.animation,
            alpha: true,
            backgroundColor: '#00000000',
            fitToCanvas: true,
            success: () => {
                if (this.props.onAnimationReady) {
                    this.props.onAnimationReady();
                }
            },
            error: () => {
                this.props.onFileLoadingError();
            },
        });
        this.addOwlyTextEquivalent();
        if (this.props.isAnimationVisualReduced) {
            this.widget.pause();
        }
    }

    componentDidUpdate(prevProps) {
        const isAnimationChanged = this.props.animation !== prevProps.animation;
        const isReductionStateChanged = this.props.isAnimationVisualReduced !== prevProps.isAnimationVisualReduced;
        if (isAnimationChanged) {
            this.widget.setAnimation(this.props.animation);
        }
        if (isReductionStateChanged || isAnimationChanged) {
            if (this.props.isAnimationVisualReduced) {
                this.widget.pause();
            } else if (!this.widget.isPlaying()) {
                this.widget.play();
            }
        } else if (this.props.animation === null) {
            this.widget.pause();
        }
    }

    addOwlyTextEquivalent = () => {
        const owlyDescription = document.createElement('span');
        owlyDescription.textContent = 'Owly speaker';
        const canvasQuery = document.getElementsByTagName('canvas');
        const owlyAnimation = canvasQuery[0];
        owlyAnimation.appendChild(owlyDescription);
    }

    render() {
        return (
            <div
                role="button"
                aria-pressed={this.isPressed}
                tabIndex={this.props.tabIndex}
                ref={(component) => { this.animationWidget = component; }}
                className={this.props.class}
                onClick={this.props.onClick}
                onKeyDown={(e) => actionOnKeyboardPress(e, this.props.onClick)}
                onTransitionEnd={this.props.onTransitionEnd}
                aria-label="Owly speaker"
            />
        );
    }
}

AnimationView.propTypes = {
    class: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    animationId: PropTypes.string.isRequired,
    animation: PropTypes.string.isRequired,
    onAnimationReady: PropTypes.func,
    onTransitionEnd: PropTypes.func,
    onFileLoadingError: PropTypes.func,
    tabIndex: PropTypes.string,
    isAnimationVisualReduced: PropTypes.bool.isRequired,
};

AnimationView.defaultProps = {
    class: '',
    onAnimationReady: undefined,
    onTransitionEnd: undefined,
    onFileLoadingError: () => {},
    tabIndex: '-1'
};
